var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"app"}},[(_vm.loading)?_c('FullScreenLoader'):_c('MainView',{staticClass:"position-relative app-container",attrs:{"isPatron":_vm.isPatron},scopedSlots:_vm._u([{key:"footer",fn:function(){return [_c('Footer')]},proxy:true}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }